import { render, staticRenderFns } from "./AssignStatusOnAccountSDData.vue?vue&type=template&id=329a49ca&scoped=true"
import script from "./AssignStatusOnAccountSDData.vue?vue&type=script&lang=js"
export * from "./AssignStatusOnAccountSDData.vue?vue&type=script&lang=js"
import style0 from "./AssignStatusOnAccountSDData.vue?vue&type=style&index=0&id=329a49ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a49ca",
  null
  
)

export default component.exports